import Phaser from 'phaser';
import { SceneKeys } from '../../game/Constants';
import { VisualTheme } from '../VisualTheme';
import { createTextButton } from './UIButton';

export function drawScreenBackground(scene: Phaser.Scene, title: string, subtitle?: string) {
  const { width, height } = scene.scale;
  scene.add.rectangle(width / 2, height / 2, width, height, VisualTheme.colors.ink);
  scene.add.rectangle(width / 2, height / 2 + 80, width, height - 160, VisualTheme.colors.slate, 0.55);

  for (let index = 0; index < 10; index++) {
    scene.add.rectangle(index * 180 - 20, height / 2 + 70, 92, height - 150, index % 2 ? 0x1d2a38 : 0x16222e, 0.12)
      .setRotation(-0.05);
  }

  scene.add.rectangle(width / 2 + 5, 53, width - 12, 96, VisualTheme.colors.shadow, 0.55);
  scene.add.rectangle(width / 2, 48, width, 96, VisualTheme.colors.night, 0.97)
    .setStrokeStyle(2, VisualTheme.colors.gold, 0.95);
  scene.add.rectangle(width / 2, 91, width - 32, 2, VisualTheme.colors.goldBright, 0.42);
  scene.add.circle(18, 48, 5, VisualTheme.colors.goldBright, 0.75);
  scene.add.circle(width - 18, 48, 5, VisualTheme.colors.goldBright, 0.75);

  scene.add.text(32, 22, title, {
    fontFamily: VisualTheme.fonts.display,
    fontSize: '35px',
    color: VisualTheme.text.title,
    stroke: '#160e08',
    strokeThickness: 2,
  });
  if (subtitle) {
    scene.add.text(34, 65, subtitle, {
      fontFamily: VisualTheme.fonts.body,
      fontSize: '16px',
      color: VisualTheme.text.accent,
    });
  }
}

export function drawPanel(scene: Phaser.Scene, x: number, y: number, width: number, height: number, title?: string) {
  scene.add.rectangle(x + 6, y + 8, width, height, VisualTheme.colors.shadow, 0.5);
  const rect = scene.add.rectangle(x, y, width, height, VisualTheme.colors.night, 0.95)
    .setStrokeStyle(2, VisualTheme.colors.gold, 0.92);
  scene.add.rectangle(x, y, Math.max(1, width - 12), Math.max(1, height - 12), 0x000000, 0)
    .setStrokeStyle(1, VisualTheme.colors.goldBright, 0.16);

  const cornerOffsetX = width / 2 - 14;
  const cornerOffsetY = height / 2 - 14;
  [[-cornerOffsetX, -cornerOffsetY], [cornerOffsetX, -cornerOffsetY], [-cornerOffsetX, cornerOffsetY], [cornerOffsetX, cornerOffsetY]]
    .forEach(([offsetX, offsetY]) => scene.add.circle(x + offsetX, y + offsetY, 2.2, VisualTheme.colors.goldBright, 0.7));

  if (title) {
    scene.add.text(x - width / 2 + 20, y - height / 2 + 14, title, {
      fontFamily: VisualTheme.fonts.display,
      fontSize: '23px',
      color: VisualTheme.text.title,
      stroke: '#160e08',
      strokeThickness: 1,
    });
    scene.add.rectangle(x, y - height / 2 + 48, width - 34, 1, VisualTheme.colors.gold, 0.32);
  }
  return rect;
}

export function addBackButton(scene: Phaser.Scene, label = 'Back to Campaign') {
  return createTextButton(scene, {
    label,
    x: scene.scale.width - 150,
    y: 48,
    width: 250,
    height: 42,
    fontSize: 18,
    onClick: () => scene.scene.start(SceneKeys.CampaignMap),
  });
}

export function addMetric(scene: Phaser.Scene, x: number, y: number, label: string, value: string | number, color: string = VisualTheme.text.body) {
  scene.add.text(x, y, label.toUpperCase(), {
    fontFamily: VisualTheme.fonts.body,
    fontSize: '12px',
    color: VisualTheme.text.muted,
    letterSpacing: 1,
  });
  scene.add.text(x, y + 17, String(value), {
    fontFamily: VisualTheme.fonts.display,
    fontSize: '23px',
    color,
    stroke: '#0b0806',
    strokeThickness: 1,
  });
}
